import { createAsyncThunk } from "@reduxjs/toolkit";

import { identifyUser } from "@/features/analytics";
import { getUser } from "@/features/user/user-reducer";
import type { RootState } from "@/redux/store";

export const analyticsIdentify = createAsyncThunk(
  "analytics/identify",
  async (_, { getState }) => {
    const state = getState() as RootState;
    const user = getUser(state);

    if (user?.external_id) {
      await identifyUser(user.external_id);
    }
  }
);
